var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

pym.then(child => {
  let params = new URLSearchParams(document.location.search);
  let id = params.get("id");
  if (id) {
    document.querySelector("body").dataset.id = id;
  }

  child.sendHeight();
  window.addEventListener("resize", () => child.sendHeight());
});
